// extracted by mini-css-extract-plugin
export default {"control":"Product_control__aGZRz","richText":"Product_richText__56OLX"};